import { render } from "./ScreenSlide.vue?vue&type=template&id=19ab4349&scoped=true&ts=true"
import script from "./ScreenSlide.vue?vue&type=script&lang=ts"
export * from "./ScreenSlide.vue?vue&type=script&lang=ts"

import "./ScreenSlide.vue?vue&type=style&index=0&id=19ab4349&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ab4349"]])

export default __exports__